import type {Acl} from '@myparcel-frontend/types';
import {defineStore} from 'pinia';
import {computed, ref} from 'vue';

export const useAclStore = defineStore('aclStore', () => {
  const acl = ref<Acl>({});

  const setAcl = (newAcl: Acl) => {
    acl.value = newAcl;
  };

  const subscriptionConfiguration = computed(() => {
    return acl.value.subscription_configuration;
  });

  return {
    acl,
    subscriptionConfiguration,
    setAcl,
  };
});
